import { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Preloader from "@/components/Preloader";

export const SiteLayout = () => {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const [introDone, setIntroDone] = useState(false);
  const finishIntro = useCallback(() => setIntroDone(true), []);
  const goTop = () => { window.__lenis?.scrollTo(0, { immediate: true, force: true }); window.scrollTo({ top: 0, behavior: "instant" }); };
  useEffect(() => { goTop(); }, [pathname]);
  useEffect(() => {
    const routeNames = { "/work": t("nav.work"), "/services": t("nav.services"), "/studio": t("nav.founders"), "/contact": t("nav.cta") };
    document.title = routeNames[pathname] ? `${routeNames[pathname]} — Web Builders` : "Web Builders — Custom Websites by Twin Prodigies";
  }, [pathname, t]);
  return <div className="relative min-h-screen bg-void text-white">
    <div className="pointer-events-none fixed inset-0 z-[60] grain opacity-[0.025] mix-blend-overlay" aria-hidden="true" />
    {!introDone && <Preloader onDone={finishIntro} />}
    <div inert={!introDone ? true : undefined} aria-hidden={!introDone ? true : undefined}>
      <a href="#main-content" data-testid="skip-content-link" className="skip-link">{t("refresh.skipContent")}</a>
      <Nav /><main id="main-content"><Outlet context={{ introDone }} /></main>
      <Footer onReplay={() => { goTop(); setIntroDone(false); }} />
    </div>
  </div>;
};